if (!customElements.get('ym-print-preview')) {
  customElements.define('ym-print-preview', class extends HTMLElement {
    static files = new Map();
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.slots = [...this.querySelectorAll('[data-slot]')];
      try { this.variants = JSON.parse(this.querySelector('[data-print-variants]').textContent); }
      catch { this.variants = {options:[],variants:[]}; }
      const options = {signal:this.abort.signal};
      this.slots.forEach(slot => {
        const input = slot.querySelector('input[type="file"]');
        const key = this.dataset.key + '-' + slot.dataset.slot;
        const saved = this.constructor.files.get(key);
        if (saved && !input.files.length) {
          try {const transfer = new DataTransfer();transfer.items.add(saved);input.files = transfer.files;} catch {this.constructor.files.delete(key);}
        }
        input.addEventListener('change', () => {
          const file = input.files[0];
          if (file) this.constructor.files.set(key,file); else this.constructor.files.delete(key);
          this.load(slot,file);
        },options);
        slot.querySelector('[data-print-remove]').addEventListener('click', () => {
          input.value = '';
          this.constructor.files.delete(key);
          this.load(slot,null);
        },options);
        this.load(slot,input.files[0]);
      });
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      document.addEventListener('change',this.schedule,options);
      this.observer = new MutationObserver(this.schedule);
      const picker = this.scope().querySelector('variant-picker');
      if (picker) this.observer.observe(picker,{childList:true,subtree:true,attributes:true,attributeFilter:['selected','checked','data-current-checked']});
      const variantInput = document.getElementById(this.dataset.formId)?.querySelector('[name="id"]');
      if (variantInput) this.observer.observe(variantInput,{attributes:true,attributeFilter:['value']});
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.slots?.forEach(slot => {if(slot.previewUrl) URL.revokeObjectURL(slot.previewUrl);});
    }
    scope() {return this.closest('.shopify-section') || this.closest('section') || this.parentElement;}
    status(slot,text) {
      const p = slot.querySelector('[data-print-status]');
      if (p.textContent !== text) p.textContent = text;
    }
    load(slot,file) {
      const ticket = slot.previewTicket = (slot.previewTicket || 0) + 1;
      const image = slot.querySelector('[data-print-image]');
      const stage = slot.querySelector('[data-print-stage]');
      if(slot.previewUrl) URL.revokeObjectURL(slot.previewUrl);
      image.onload = null;image.onerror = null;image.removeAttribute('src');
      stage.hidden = true;
      slot.querySelector('[data-print-remove]').hidden = !file;
      if(!file) {this.status(slot,this.dataset.empty);return;}
      if(!/\.(png|jpe?g|svg)$/i.test(file.name)) {this.status(slot,this.dataset.pdf);return;}
      if(file.size>20*1024*1024) {this.status(slot,this.dataset.large);return;}
      this.status(slot,this.dataset.loading);
      image.onload = () => {
        if(slot.previewTicket!==ticket || !this.isConnected) return;
        stage.hidden=false;
        slot.imageRatio=image.naturalWidth/image.naturalHeight;
        this.status(slot,file.name);
        this.sync();
      };
      image.onerror = () => {if(slot.previewTicket===ticket) this.status(slot,this.dataset.error);};
      slot.previewUrl=URL.createObjectURL(file);
      image.src=slot.previewUrl;
    }
    sync() {
      if(!this.isConnected) return;
      const variantId=document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value;
      const variant=this.variants.variants.find(v=>String(v.id)===String(variantId));
      const options=variant?.options || [];
      const sizeIndex=this.variants.options.findIndex(name=>/size|medida|tamañ/i.test(name));
      let ratio=Number(this.dataset.ratio);
      if(sizeIndex>=0 && ['banner','label'].includes(this.dataset.mode)) {
        const match=(options[sizeIndex] || '').replace(/,/g,'.').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
        if(match && Number(match[2])>0) ratio=Number(match[1])/Number(match[2]);
      }
      for(const slot of this.slots) {
        const safeRatio=ratio>0?ratio:(slot.imageRatio || 1);
        const sheet=slot.querySelector('[data-print-sheet]');
        const value=String(safeRatio);
        if(sheet.style.getPropertyValue('--print-ratio')!==value) sheet.style.setProperty('--print-ratio',value);
      }
      const text=options.filter(v=>v!=='Default Title').join(' · ');
      const selection=this.querySelector('[data-print-selection]');
      if(selection.textContent!==text) selection.textContent=text;
    }
  });
}
